type Props = {
  className?: string
}

export default function IconCheck({ className }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}>
      <path
        d="M12.7365 3.96993C12.8047 3.9003 12.8862 3.84498 12.9761 3.80722C13.0659 3.76945 13.1625 3.75 13.26 3.75C13.3575 3.75 13.454 3.76945 13.5439 3.80722C13.6338 3.84498 13.7152 3.9003 13.7835 3.96993C14.0695 4.25893 14.0735 4.72593 13.7935 5.01993L7.88047 12.0099C7.81333 12.0837 7.73187 12.1429 7.64105 12.1841C7.55023 12.2252 7.45197 12.2474 7.35227 12.2493C7.25258 12.2511 7.15356 12.2327 7.06126 12.1949C6.96896 12.1572 6.88532 12.1011 6.81547 12.0299L3.21747 8.38393C3.07871 8.24242 3.00098 8.05213 3.00098 7.85393C3.00098 7.65574 3.07871 7.46545 3.21747 7.32393C3.28571 7.2543 3.36717 7.19898 3.45706 7.16122C3.54695 7.12345 3.64347 7.104 3.74097 7.104C3.83847 7.104 3.93499 7.12345 4.02488 7.16122C4.11477 7.19898 4.19622 7.2543 4.26447 7.32393L7.31647 10.4169L12.7165 3.99193C12.7227 3.98421 12.7294 3.97686 12.7365 3.96993Z"
        fill="currentColor"
      />
    </svg>
  )
}
